import { NgIf } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IconComponent } from 'src/app/core/icon/icon.component';
import { PaymentService } from '@services/payment/payment.service';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';

@Component({
  selector: 'app-donate-btn-v2',
  standalone: true,
  imports: [
    NgIf,
    IconComponent,
    CurrencyIconComponent,
  ],
  templateUrl: './donate-btn-v2.component.html',
  styleUrls: ['./donate-btn-v2.component.scss']
})
export class DonateBtnV2Component {

  readonly payment = inject(PaymentService);

  @Input() currency: string = 'INR';
  @Input() amount: number = 0;
  @Input() isLoading: boolean = false;
  @Output() payUsingOther = new EventEmitter<boolean>();

  togglePaymentMode() {
    this.payUsingOther.emit(true);
  }
}
